<script setup lang="ts">
import { useUserStore } from '@/store/user';
import { login } from '@/utils/helper/auth';

const userStore = useUserStore();
const isLoggedIn = computed(() => userStore.getLoggedIn);

const handleLogin = () => {
	login();
};
</script>
<template>
	<div class="mobile-user-menu">
		<user-menu v-if="isLoggedIn"></user-menu>
		<div v-else class="w-full flex flex-col items-center mt-10">
			<div class="mb-6 text-xl text-center">
				<p>{{ $t('notLoginHint') }}</p>
				<p>{{ $t('loginHint') }}</p>
			</div>
			<el-button id="mobile-side-nav-login-btn" type="primary" round @click="handleLogin">
				<p class="uppercase font-bold">{{ $t('login') }}</p>
			</el-button>
		</div>
	</div>
</template>
<style lang="scss" scope>
@import '@/assets/scss/components/mobile-user-menu.scss';
</style>
